export function XeroSupportFindInvoiceByInvoiceNumberCtrl ($scope, $uibModalInstance, workshopAPI, invoice) {

  $scope.invoice = invoice ? invoice : {};

}